<template>
	<div class="app flex-row align-items-center">
		<div class="error-info errorservice">
      <img src="@/assets/images/logo.png">
			<h3>Bakımdayız!</h3>
			<p>En kısa sürede sizlerle beraber olacağız...</p>
		</div>
	</div>
</template>
<script>
  export default {
    name: 'Maintenance',
    beforeRouteLeave (to, from, next) {
      if(this.$store.getters.getMaintenanceStatus){
        next(false)
      }else{
        next()
      }
    },
    mounted(){
      if(!this.$store.getters.getMaintenanceStatus){
        this.$router.push({name: 'Homepage'});
      }
    }
  }
</script>

<style>

</style>